var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgH3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.28 21.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-H3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16,10.06c-.94.08-2.62,3.09-2.88,4A16.58,16.58,0,0,0,0,18.35a3.64,3.64,0,0,0,.54,1.83c1.31,1.87,11.68,1.24,12.67.69.71-.41-.36-1.23-.68-1.88a6.42,6.42,0,0,1,.24-6.27c.36-.48.66-.79,0-1.44-2.23-2.22-1.39-.43-4.31.1a7.67,7.67,0,0,1-5.33-1.32Z",
    transform: "translate(0 0)",
    fill: "#385799",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.67,0C0,.83,1.29,11,7.91,10.12S13.35-.74,6.67,0Z",
    transform: "translate(0 0)",
    fill: "#385799",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.64,19.92c3.27-2.83,1.52-9.55-4-8.9-5,.59-5.51,6.34-2.75,8.9a4.77,4.77,0,0,0,4,1.18A5.14,5.14,0,0,0,21.64,19.92ZM17.58,14.5a.69.69,0,0,1,1.38,0v.8h.79a.69.69,0,1,1,0,1.38H19v.79a.69.69,0,0,1-1.38,0v-.79h-.79a.69.69,0,0,1,0-1.38h.79Z",
    transform: "translate(0 0)",
    fill: "#385799",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH3);
export default __webpack_public_path__ + "static/media/H3.2906aa31bd8d2a6112bbe5ab2aa1017f.svg";
export { ForwardRef as ReactComponent };